import React from 'react'
import { updateObject } from 'helpers/objectHelpers'
import FormLanguage from 'components/forms/FormLanguage'
import FormImageElement from 'components/forms/image/FormImageElement'

const CardContent = ({
  value,
  value: {
    source = '',
    link = '',
    target = '',
    header = '',
    description = '',
  },
  onChange,
  currentLang,
}) => {
  const handleChange = (val, key) => {
    return onChange(updateObject(value, { [key]: val }))
  }
  return (
    <div>
      <FormImageElement
        value={value}
        onChange={onChange}
      />
      <FormLanguage
        value={header}
        onChange={val => handleChange(val, 'header')}
        label="Header"
        inputStyle={{ fontSize: 12 }}
        currentLang={currentLang}
      />
      <FormLanguage
        value={description}
        onChange={val => handleChange(val, 'description')}
        label="Description"
        inputStyle={{ fontSize: 12 }}
      />
    </div>
  )
}

CardContent.propTypes = {}
CardContent.defaultProps = {}

export default CardContent



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/elementForms/card/CardContent.js